(() => {
  const DAY = 86400000;
  const own = item => item.properties?._cf_promo_gift === 'replica';
  const durations = {family: 2 * DAY, share: 2 * DAY};
  function phase(config, now, forced) {
    if (!config.enabled) return null;
    if (config.mode === 'permanent') return config.offers?.family === false ? null : {offer: 'family', permanent: true};
    const offers = ['family', 'share'].filter(key => config.offers?.[key] !== false);
    if (!offers.length) return null;
    if (config.demo) {
      if (!Number.isFinite(config.anchor) || now < config.anchor || now >= config.testEnd) return null;
      if (offers.includes(forced)) {
        const duration = durations[forced];
        const start = config.anchor + Math.floor((now - config.anchor) / duration) * duration;
        return {offer: forced, start, end: Math.min(start + duration, config.testEnd)};
      }
      const length = offers.reduce((sum, key) => sum + durations[key], 0);
      const cycle = Math.floor((now - config.anchor) / length);
      if (config.repeat === false && cycle > 0) return null;
      let start = config.anchor + cycle * length;
      for (const offer of offers) {
        const end = start + durations[offer];
        if (now < end) return {offer, start, end: Math.min(end, config.testEnd)};
        start = end;
      }
      return null;
    }
    let windows = config.windows || [];
    try { if (typeof windows === 'string') windows = JSON.parse(windows); } catch { return null; }
    if (!Array.isArray(windows)) return null;
    const signature = [config.enabled, config.anchor, config.repeat, config.offers?.family !== false, config.offers?.share !== false].join('|');
    return windows.find(w => w.signature === signature && offers.includes(w.offer) && w.verified === true && Number.isFinite(w.start) && Number.isFinite(w.end) && w.end - w.start === durations[w.offer] && now >= w.start && now < w.end) || null;
  }
  function codes(cart) {
    const result = new Set((cart.discount_codes || []).filter(d => d.applicable !== false).map(d => d.code.toUpperCase()));
    const allocations = [...(cart.cart_level_discount_applications || []), ...cart.items.flatMap(i => (i.line_level_discount_allocations || []).map(a => a.discount_application))];
    allocations.filter(a => a.type === 'discount_code').forEach(a => result.add(a.title.toUpperCase()));
    return [...result];
  }
  const cleanup = cart => Object.fromEntries(cart.items.filter(own).map(item => [item.key, 0]));
  const exported = {phase, codes, cleanup};
  if (typeof module !== 'undefined' && module.exports) module.exports = exported;
  if (typeof document === 'undefined') return;
  let node = document.getElementById('cf-promotion-config');
  if (!node || window.cfPromotions) return;
  let config = JSON.parse(node.textContent);
  const model = window.cfCreationCart;
  if (!model) return;
  const base = window.Shopify?.routes?.root || '/', nativeFetch = window.fetch.bind(window);
  const initial = Date.now(), elapsed = performance.now(), offset = config.serverNow - initial;
  const now = () => initial + offset + performance.now() - elapsed;
  const current = () => phase(config, now(), config.demo ? new URL(location.href).searchParams.get('cf_offer') || config.previewOffer : null);
  const t = key => config.strings[key] || key;
  let running = null, queued = false, ownRequest = 0, error = null, lastPhase = '', scheduled;
  async function request(path, body) {
    ownRequest++;
    try {
      const response = await nativeFetch(base + path, {method:body ? 'POST':'GET', credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json', ...(body ? {'Content-Type':'application/json'}:{})}, ...(body ? {body:JSON.stringify(body)}:{})});
      const data = await response.json();
      if (!response.ok || data.errors) throw Error(data.description || t('error'));
      return data;
    } finally { ownRequest--; }
  }
  function notice(message) {
    let status = document.getElementById('cf-promotion-status');
    if (!status) {status = document.createElement('p');status.id='cf-promotion-status';status.className='cf-promotion-status';status.setAttribute('role','alert');(document.querySelector('#main-cart-items') || document.querySelector('main') || document.body).prepend(status);}
    status.textContent = message;
    status.hidden = !message;
  }
  async function pass() {
    node.dataset.sync = 'reading';
    let cart = await request('cart.js'), changed = false;
    node.dataset.sync = 'planning';
    const updates = cleanup(cart);
    if (Object.keys(updates).length) {cart = await request('cart/update.js',{updates});changed=true;}
    {
      const previous = [...new Set([...codes(cart), ...(cart.discount_codes || []).map(d=>d.code.toUpperCase())])], next = previous.filter(c => c !== config.retiredCode.toUpperCase());
      if ([...previous].sort().join(',') !== next.map(c=>c.toUpperCase()).sort().join(',')) {cart=await request('cart/update.js',{discount:next.join(',')});changed=true;}
    }
    error=null;notice('');node.dataset.sync='complete';
    document.dispatchEvent(new CustomEvent('cf:promotion-synced',{detail:{cart,changed}}));
    if(changed) document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart}}));
    return {cart,changed};
  }
  function sync() {
    if (config.editor) return Promise.resolve({changed:false});
    if (running) {queued=true;return running;}
    running=(async()=>{let result,changed=false;do {queued=false;result=await pass();changed=changed||result.changed;}while(queued);return {...result,changed};})().catch(e=>{error=e;node.dataset.sync='error';notice(e.message);throw e;}).finally(()=>{running=null;});
    return running;
  }
  function schedule() {clearTimeout(scheduled);scheduled=setTimeout(()=>sync().then(result=>{if(result.changed && config.cartPage) location.reload();}).catch(()=>{}),150);}
  window.cfPromotions={sync,current,codes,get error(){return error;}};
  window.fetch=async function(input,init) {
    const response=await nativeFetch(input,init);
    const url=typeof input==='string'?input:input?.url || String(input);
    if(!ownRequest && response.ok && /\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/.test(url)) schedule();
    return response;
  };
  document.addEventListener('cart:updated',()=>{if(!running)schedule();});
  document.addEventListener('visibilitychange',()=>{if(!document.hidden){tick();schedule();}});
  window.addEventListener('pageshow',schedule);
  window.addEventListener('focus',schedule);
  function tick() {
    const active=current(), marker=active?active.offer+active.end:'';
    document.documentElement.dataset.cfPromotion=active?.offer || 'none';
    document.querySelectorAll('.cf-promotion[data-cf-promotion]').forEach(host=>{
      host.hidden=!active;
      host.querySelector('[data-cf-countdown]').hidden=!!active?.permanent;
      host.querySelector('[data-cf-permanent-badge]').hidden=!active?.permanent;
      host.querySelector('[data-cf-timer-icon]').toggleAttribute('hidden',!!active?.permanent);
      host.querySelectorAll('[data-cf-phase]').forEach(panel=>panel.hidden=panel.dataset.cfPhase!==active?.offer);
      if(active && !active.permanent){const seconds=Math.max(0,Math.ceil((active.end-now())/1000));host.querySelector('[data-cf-countdown]').textContent=Math.floor(seconds/3600)+' h : '+String(Math.floor(seconds%3600/60)).padStart(2,'0')+' m : '+String(seconds%60).padStart(2,'0')+' s';}
    });
    document.querySelectorAll('[data-cf-manager-status]').forEach(el=>{el.textContent=!config.enabled?'Désactivé':active?.permanent?'Offre famille permanente · sans compteur':active?({family:'Les 48 h famille',share:'Les jours à partager'}[active.offer])+' · '+(config.demo?'aperçu de test':'fenêtre validée'):'Aucune offre active';});
    if(lastPhase!==marker)schedule();
    lastPhase=marker;
  }
  document.addEventListener('click',async e=>{
    const button=e.target.closest('[data-cf-promo-copy]');if(!button)return;
    const host=button.closest('[data-cf-promotion]');if(button.closest('[data-cf-phase]').dataset.cfPhase!==current()?.offer)return;
    const status=host.querySelector('[role="status"]');
    try{await navigator.clipboard.writeText(button.dataset.cfPromoCopy);status.textContent=t('copied');}catch{status.textContent=button.dataset.cfPromoCopy;}
  });
  document.addEventListener('shopify:section:load',()=>{const next=document.getElementById('cf-promotion-config');if(next){node=next;config=JSON.parse(next.textContent);}tick();});
  tick();setInterval(tick,1000);
  sync().then(result=>{if(result.changed && config.cartPage) location.reload();}).catch(()=>{});
})();

